import React from "react";
import "./AboutBanner.css";
import { Link } from "react-router-dom";

export default function AboutBanner() {
  return (
   <section className=" container-fluid ayb-wrapperr d-flex align-items-center">
   <div className="container p-4">
          <div className="ay-banner-content">
             <p style={{color:'wheat',textAlign:'center',fontSize:'30px',fontWeight:'500',fontFamily:'serif'}} >
              You’ve found the right door to traditional healing—a path to restore, rejuvenate, and revive your body and mind.
            </p>

            
          </div>
        </div>
</section>

  );
}
